import React from 'react';

const SettingsContext = React.createContext(null);

export default SettingsContext;
